'use strict';

module.exports = {
	showStoreAvailabilityModal: function () {
		$('body').on('click', '.js-btn-check-store-availability', function (event) {
			event.preventDefault();
			$('#check-store-availability-modal').modal('toggle');
		});
	}
};
